// extracted by mini-css-extract-plugin
export var button = "CallToAction-module--button--7daf8";
export var buttonRow = "CallToAction-module--buttonRow--92a70";
export var container = "CallToAction-module--container--03709";
export var fadeInAnimation = "CallToAction-module--fadeInAnimation--50b8a";
export var image = "CallToAction-module--image--69128";
export var link = "CallToAction-module--link--68b43";
export var picture = "CallToAction-module--picture--75e10";
export var titleRow = "CallToAction-module--titleRow--4c6b8";
export var width800 = "CallToAction-module--width800--b3afc";
export var withImg = "CallToAction-module--withImg--2e00d";
export var wrapper = "CallToAction-module--wrapper--c667e";